const setFlag = (flags, flag) => flags | flag
const clearFlag = (flags, flag) => flags & ~flag
const flagIsSet = (flags, flag) => (flags & flag) != 0 // eslint-disable-line eqeqeq

module.exports = { setFlag, clearFlag, flagIsSet }
